import store from '@/store'

export default function({ next, to }) {
  if (store.getters.authenticated) {
    next()
  } else {
    next({ name: 'login', query: { redirectTo: to.fullPath } })
  }
}
